import React, { useContext } from "react";
import { Stores, StoresContext } from "./Custom/Stores";

//import { Samples } from "./Custom/Views/Samples";
//import { LogViewer } from "./Core/Views/LogViewer";
import { Route } from "react-router";
//import { SessionExpired } from "./Custom/Views/SessionExpired";
//import { TestPage } from "./Core/Views/TestPage";
import { Home } from "./Custom/Views/Home";
import { CookieError } from "./Custom/Views/CookieError";
import { Error2 } from "./Core/Views/Error2";
import { NotFound } from "./Core/Views/NotFound";

export const AppRoutes: React.FC = () => {
    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <Route component={Home} exact path="/" />
            <Route component={CookieError} exact path="/cookieerror" />
            <Route component={Error2} exact path="/error" />
            <Route component={NotFound} exact path="/notfound" />

            {/* Delete / comment out these routes later
            <Route component={LogViewer} exact path="/logviewer" />
            <Route component={Samples} exact path="/samples" />

            <Route component={TestPage} exact path="/test" />
            */}
        </>
    );
};
